import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { usePosts } from "../Hooks/usePosts";
import Footer from "../components/Partials/Footers/HomeOne/Footer";
import BackToTop from "../components/Helpers/BackToTop";
import useToggle from "../Hooks/useToggle";
import Drawer from "../components/Mobile/Drawer";

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("s") || "";
  const { data: posts, isLoading } = usePosts();
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [drawer, setDrawer] = useToggle(false);

  useEffect(() => {
    if (posts && searchQuery) {
      const filtered = posts.filter((post) => {
        const titleMatch = post.title
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase());
        const excerptMatch = post.excerpt
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase());
        const contentMatch = post.content
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase());
        return titleMatch || excerptMatch || contentMatch;
      });
      setFilteredPosts(filtered);
    } else {
      setFilteredPosts([]);
    }
  }, [posts, searchQuery]);

  const PostCard = ({ post }) => {
    return (
      <div className="col-lg-4 col-md-6 mb-4">
        <article className="news-card">
          <Link to={`/news/${post.id}`} className="news-link">
            <div className="news-image">
              <img src={post.image_url} alt={post.title} />
              {post.categories && post.categories[0] && (
                <div className="news-overlay">
                  <span className="news-category">
                    <i className="fas fa-tag"></i>
                    {post.categories[0]}
                  </span>
                </div>
              )}
            </div>
            <div className="news-content">
              <div className="news-meta">
                <span className="news-date">
                  <i className="fas fa-calendar-alt"></i>
                  {new Date(post.created_at).toLocaleDateString("sq-AL")}
                </span>
              </div>
              <h4 className="news-title">{post.title}</h4>
              {post.excerpt && (
                <p className="news-excerpt">
                  {post.excerpt.length > 120
                    ? post.excerpt.substring(0, 120) + "..."
                    : post.excerpt}
                </p>
              )}
              <div className="news-footer">
                <span className="news-arrow">
                  <i className="fas fa-arrow-right"></i>
                </span>
              </div>
            </div>
          </Link>
        </article>
      </div>
    );
  };

  if (isLoading) {
    return (
      <>
        <Drawer drawer={drawer} action={setDrawer.toggle} />
        <div className="loading-container">
          <div className="loading-content">
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
            <p>Duke kërkuar...</p>
          </div>
        </div>
        <Footer />
        <BackToTop />
      </>
    );
  }

  return (
    <>
      <Drawer drawer={drawer} action={setDrawer.toggle} />

      {/* Search Results Header */}
      <section className="search-header-section">
        <div className="container">
          <div className="search-header-content">
            <h1 className="search-title">Rezultatet e kërkimit</h1>
            {searchQuery && (
              <div className="search-info">
                <p className="search-query">
                  Kërkimi për: <strong>"{searchQuery}"</strong>
                </p>
                <p className="search-count">
                  {filteredPosts.length} rezultate të gjetura
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Search Results Content */}
      <section className="search-results-section">
        <div className="container">
          {searchQuery ? (
            filteredPosts.length > 0 ? (
              <div className="row">
                {filteredPosts.map((post) => (
                  <PostCard key={post.id} post={post} />
                ))}
              </div>
            ) : (
              <div className="no-results">
                <div className="no-results-content">
                  <div className="no-results-icon">
                    <i className="fas fa-search"></i>
                  </div>
                  <h2>Asnjë rezultat i gjetur</h2>
                  <p>
                    Nuk u gjet asnjë lajm që përputhet me kërkimin tuaj për "
                    {searchQuery}". Provoni të përdorni terma të tjera kërkimi.
                  </p>
                  <Link to="/" className="btn-back-home">
                    <i className="fas fa-home"></i> Kthehu në Ballina
                  </Link>
                </div>
              </div>
            )
          ) : (
            <div className="no-query">
              <div className="no-query-content">
                <div className="no-query-icon">
                  <i className="fas fa-keyboard"></i>
                </div>
                <h2>Shkruani një term kërkimi</h2>
                <p>Përdorni kutinë e kërkimit për të gjetur lajme.</p>
                <Link to="/" className="btn-back-home">
                  <i className="fas fa-home"></i> Kthehu në Ballina
                </Link>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default SearchResults;
